var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.deliverable
    ? _c(
        "div",
        { staticClass: "deliverable-list-tags" },
        [
          _c("span", { staticClass: "text-uppercase field-label" }, [
            _vm._v("Tags")
          ]),
          _vm._v(" "),
          _c("perfect-scrollbar", { ref: "deliverable__tags__scroll" }, [
            _vm.deliverable.tags
              ? _c(
                  "div",
                  {
                    staticClass:
                      "info-bubbles cursor-pointer exclude-outside-click",
                    on: { click: _vm.showAddTag }
                  },
                  [
                    _vm._l(_vm.deliverable.tags, function(tag, index) {
                      return _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !_vm.addTagFlag,
                              expression: "!addTagFlag"
                            }
                          ],
                          key: index,
                          staticClass:
                            "exclude-outside-click badge badge-gray deliverable-tags"
                        },
                        [_vm._v(_vm._s(tag.name))]
                      )
                    }),
                    _vm._v(" "),
                    _vm.deliverable.tags.length == 0
                      ? _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !_vm.addTagFlag,
                                expression: "!addTagFlag"
                              }
                            ],
                            staticClass:
                              "exclude-outside-click badge badge-gray deliverable-tags"
                          },
                          [_vm._v("No Tags")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("plus-button", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.addTagFlag,
                          expression: "!addTagFlag"
                        }
                      ],
                      staticClass: "tagged-tags"
                    })
                  ],
                  2
                )
              : _vm._e()
          ]),
          _vm._v(" "),
          _vm.deliverable.tags
            ? _c("multiselect", {
                directives: [
                  {
                    name: "click-outside",
                    rawName: "v-click-outside",
                    value: _vm.outside,
                    expression: "outside"
                  },
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.addTagFlag,
                    expression: "addTagFlag"
                  }
                ],
                ref: "deliverableListTags",
                attrs: {
                  "close-on-select": false,
                  options: _vm.tags,
                  "show-labels": false,
                  multiple: true,
                  taggable: true,
                  label: "name",
                  "track-by": "id",
                  id: _vm.deliverable.id
                },
                on: {
                  tag: _vm.createTags,
                  input: function($event) {
                    return _vm.updateFieldValue(_vm.deliverable)
                  },
                  "search-change": _vm.onTagSearch,
                  open: function($event) {
                    return _vm.onTagSearch(false)
                  },
                  close: function($event) {
                    _vm.addTagFlag = false
                  }
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "noOptions",
                      fn: function(props) {
                        return [
                          _vm._v("\n      Start typing to find tags.\n    ")
                        ]
                      }
                    },
                    {
                      key: "noResult",
                      fn: function(props) {
                        return [_vm._v("\n       \n    ")]
                      }
                    }
                  ],
                  null,
                  false,
                  1100499068
                ),
                model: {
                  value: _vm.deliverable.tags,
                  callback: function($$v) {
                    _vm.$set(_vm.deliverable, "tags", $$v)
                  },
                  expression: "deliverable.tags"
                }
              })
            : _vm._e()
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }